import {NgModule} from '@angular/core';
import {ErrorInterceptor} from '../_helpers/error.interceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {JwtInterceptor} from '../_helpers/jwt.interceptor';
import {AtomHeaderComponent} from './atom-header/atom-header.component';
import {IonicModule} from '@ionic/angular';
import {AtomTextComponent} from './atom-text/atom-text-component';
import {AtomTextBoxComponent} from './atom-text/atom.text.box.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TimeStampPipe} from '../_pipes/time.stamp.pipe';
import {SafeUrlPipe} from '../_pipes/safe.url.pipe';
import {SanitizePipe} from '../_pipes/sanitize.pipe';
import {AtomLargeHeaderComponent} from './atom-large-header/atom-large-header.component';
import {LogOutComponent} from './log-out/log-out.component';
import {MenuOptionsModalPage} from './menu-options-modal/menu-options-modal-page';
import {AtomTextIconLabelComponent} from './atom-text/atom-text-label-icon.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {AtomMediumHeaderComponent} from './atom-medium-header/atom-medium-header.component';
import {UserProfileComponent} from '../modules/user/auth/user-profile/user-profile.component';
import {SearchLocationComponent} from './search-location/search-location.component';
import {ReportCardComponent} from '../modules/user/auth/reports/report-card/report-card.component';
// import {AtomFileUploaderComponent} from './atom-file-uploader/atom-file-uploader.component';
import {ProfileComponent} from '../modules/user/auth/profile/profile.component';
import {ReportsComponent} from '../modules/user/auth/reports/reports.component';
import {GalleryComponent} from './gallery-component/gallery-component';
import {PreviewImageComponent} from './preview-image/preview-image.component';
import {MultipleSelectComponent} from './multiple-select-component/multiple-select-component';
import {AtomImageUploaderComponent} from './atom-image-uploader/atom-image-uploader.component';
import {UploaderComponent} from './image-upload/uploader.component';
import {FileViewerComponent} from './image-upload/file.viewer.component';
import {ImgFallbackDirective} from '../_helpers/image-fallback.directive';
// import {AddEmotionReportComponent} from './add-emotion-report/add-emotion-report.component';
import {TermsAndConditionComponent} from './terms-condition/terms-condition.component';
import {DeleteMyAccountComponent} from './delete-my-account/delete-my-account.component';
import {ProjectImagePipe} from '../_pipes/project-image.pipe';
import {DetectLocationComponent} from './detect-location/detect-location.component';
import {PreviewReportComponent} from './preview-report/preview-report.component';
import {LandingPreviewComponent} from './landing-preview/landing-preview.component';
import {RipplerDropDownComponent} from './drop-down/drop-down.component';
import {AppModule} from '../app.module';
import {ProjectLogoPipe} from '../_helpers/project-logo.pipe';
import {AddSiteComponent} from './add-site/add-site.component';

const commonModule = [
  ProjectLogoPipe,
  TimeStampPipe,
  SafeUrlPipe,
  SanitizePipe,
  AtomHeaderComponent,
  AtomTextComponent,
  AtomTextBoxComponent,
  AtomTextIconLabelComponent,
  AtomMediumHeaderComponent,
  AtomLargeHeaderComponent,
  LogOutComponent,
  MenuOptionsModalPage,
  AboutUsComponent,
  TermsAndConditionComponent,
  UserProfileComponent,
  SearchLocationComponent,
  ReportCardComponent,
  // AtomFileUploaderComponent,
  ProfileComponent,
  ReportsComponent,
  GalleryComponent,
  PreviewImageComponent,
  AtomImageUploaderComponent,
  MultipleSelectComponent,
  FileViewerComponent,
  ImgFallbackDirective,
  // AddEmotionReportComponent,
  DeleteMyAccountComponent,
  DetectLocationComponent,
  PreviewReportComponent,
  RipplerDropDownComponent,
  LandingPreviewComponent,
];

@NgModule({
  declarations: [
    commonModule,
    UploaderComponent,
    ProjectImagePipe
  ],
    imports: [
        IonicModule,
        TranslateModule,
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
    ],
  exports: commonModule,
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}
  ]
})
export class SharedModule {

}
